module.exports = __webpack_public_path__ + "static/media/ga.06ba250c.svg";